import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { NavParams } from '@ionic/angular';
import { PtyWsService } from 'src/app/services/pty-ws.service';

@Component({
    selector: 'app-sharing-modal',
    templateUrl: './sharing-modal.component.html',
    styleUrls: ['./sharing-modal.component.scss'],
})
export class SharingModalComponent implements OnInit {

    Verse;
    book_name;
    chapter;
    bookOrder;
    Contacts: Array<any> = [];
    dummyResponse;
    date = new Date();

    checkbox = true;
    selectedContacts = [];

    constructor(
        public modalController: ModalController,
        public navParams: NavParams,
        private ws: PtyWsService,) {

    }

    dismiss() {
        this.modalController.dismiss({
            'dismissed': true
        });
    }

    ngOnInit() {


        this.Verse = this.navParams.get('verse');
        this.book_name = this.navParams.get('book_name');
        this.chapter = this.navParams.get('chapter');
        this.bookOrder = this.navParams.get('bookOrder');


        this.getContacts();
    }


    getContacts() {
        this.ws.invokeURL('conversations', { page: 1 }).subscribe((result: any) => {
            if (result.error === 0) {
                this.Contacts = result.rows;
                this.Contacts.map((element) => {
                    element.isChecked = false;
                });
            } else {
                console.error('Error', result.message);
            }
        });
    }

    SendVerse() {
        let contact = [];
        let conversation_uuids =[];
        this.Contacts.forEach(item => {
            if (item.isChecked) {
                contact.push(item.seeker_uuid);
                conversation_uuids.push(item.uuid);
            }
        });
        // tslint:disable-next-line: max-line-length
        this.ws.invokeURL('shareVerseAsMessage',{ message: this.Verse, message_type: 'text', conversation_uuid: conversation_uuids }).subscribe((result: any) => {
            if (result.error === 0) {
                this.dismiss();
                this.SaveVerse(contact);
            } else {
                console.error('Error', result.message);
            }
        });
    }

    SaveVerse(seeker_uuid) {
        this.ws.invokeURL('AddToBibleShare', {
            verse_text: this.Verse, book_name: this.book_name, seeker_uuid: seeker_uuid,
            date: this.date, chapterId: this.chapter, bookOrder: this.bookOrder
        }).subscribe((result: any) => {
            if (result.error === 0) {
                this.dismiss();
            } else {
                console.error('Error : ', result.message);
            }
        });
    }

    getSelectedContacts($event, contact) {
        if ($event) {
            this.Contacts.map((item) => {
                if (item.uuid == contact.uuid) {
                    item.isChecked = true;
                }
            });
        } else {
            this.Contacts.map((item) => {
                if (item.uuid == contact.uuid) {
                    item.isChecked = false;
                }
            });
        }
    }
}
